(() => {
  const enhancePrivacyPolicy = () => {
    if (!window.location.pathname.includes('/policies/privacy-policy')) return;

    const container = document.querySelector('.shopify-policy__container');
    const title = document.querySelector('.shopify-policy__title');
    const rte = document.querySelector('.shopify-policy__body .rte');
    if (!container || !title || !rte || container.classList.contains('shopify-policy--enhanced')) return;

    container.classList.add('shopify-policy--enhanced');

    const firstHeading = Array.from(rte.children).find((node) => node.tagName === 'H2');
    const introNodes = [];
    let node = rte.firstElementChild;
    while (node && node !== firstHeading) {
      const next = node.nextElementSibling;
      introNodes.push(node);
      node = next;
    }

    const hero = document.createElement('section');
    hero.className = 'privacy-policy__hero';
    hero.setAttribute('aria-label', 'Resumen de la política de privacidad');

    const heroCopy = document.createElement('div');
    heroCopy.className = 'privacy-policy__hero-copy';
    heroCopy.appendChild(title);
    introNodes.forEach((introNode) => heroCopy.appendChild(introNode));

    const assurance = document.createElement('aside');
    assurance.className = 'privacy-policy__assurance';
    assurance.innerHTML = '<span class="privacy-policy__assurance-icon" aria-hidden="true">✓</span><h2>Tus datos, bajo control</h2><ul><li>Uso limitado a finalidades informadas</li><li>No vendemos datos personales</li><li>Derechos ejercitables directamente</li><li>Medidas de seguridad y confidencialidad</li></ul>';

    hero.append(heroCopy, assurance);
    container.insertBefore(hero, container.querySelector('.shopify-policy__body'));

    const facts = document.createElement('div');
    facts.className = 'privacy-policy__facts';
    facts.setAttribute('aria-label', 'Información esencial');
    facts.innerHTML = '<article class="privacy-policy__fact"><strong>Responsable</strong><span>Mínguez, S.A.</span></article><article class="privacy-policy__fact"><strong>Contacto</strong><span>minguez@minguez.es</span></article><article class="privacy-policy__fact"><strong>Base del tratamiento</strong><span>Contrato, ley, consentimiento e interés legítimo</span></article><article class="privacy-policy__fact"><strong>Autoridad de control</strong><span>Agencia Española de Protección de Datos</span></article>';
    container.insertBefore(facts, container.querySelector('.shopify-policy__body'));

    const headings = Array.from(rte.children).filter((child) => child.tagName === 'H2');
    headings.forEach((heading, index) => {
      const section = document.createElement('section');
      section.className = 'privacy-policy__section privacy-policy__section--' + (index + 1);
      rte.insertBefore(section, heading);
      let current = heading;
      const nextHeading = headings[index + 1] || null;
      while (current && current !== nextHeading) {
        const next = current.nextElementSibling;
        section.appendChild(current);
        current = next;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePrivacyPolicy);
  } else {
    enhancePrivacyPolicy();
  }
})();